import * as $ from 'jquery'
import 'bootstrap'

/**
 * From radio in a dropdown
 */

const RadioDropdown = (function() {
    var Constructor = function(element) {
        var _radioElement = $(element).find('[type=radio]');
        var _textButton = $(element).find('.text-button');

        _selectInput($(element).find('[checked]'));

        function _onRadioSelect(event) {
            var input = $(event.currentTarget);
            _selectInput(input);
        }

        function _selectInput(input) {
            if (input.data('default'))
                $(element).removeClass('active')
            else
                $(element).addClass('active')
            _textButton.html(input.data('label'));
        }

        _radioElement.on('change', _onRadioSelect)
    };
    return Constructor;
})();

const CheckboxDropdown = (function() {
    var Constructor = function(element) {
        var _checboxElement = $(element).find('[type=checkbox]');
        var _labelElement = $(element).find('label');
        var _textButton = $(element).find('.text-button');
        _selectInput($(element).find('[checked]'));

        function _onLabelClick(event) {
            // Prevent dropdown closing
            event.stopPropagation()
        }

        function _onCheckboxSelect(event) {
            event.stopPropagation()
            var input = $(event.currentTarget);
            _selectInput(input);
        }

        function _selectInput(input) {
            var str = ''
            _checboxElement.filter(':checked').each(function(i, elem){
                if (i != 0) {
                    str += ', '
                }
                str += $(elem).data('label');
            })

            if(str != '') {
              _textButton.html(str);
            } else {
              _textButton.html('-----');                
            }

        }

        _checboxElement.on('change', _onCheckboxSelect)
        _labelElement.on('click', _onLabelClick)
    };
    return Constructor;
})();

$(document).ready(function() {
    // Create all select input.
    $('.form-radio--dropdown').each(function() {
        RadioDropdown(this);
    });
    // Create all select input.
    $('.form-checkbox--dropdown').each(function() {
        CheckboxDropdown(this);
    });
});

export {RadioDropdown, CheckboxDropdown}


// WEBPACK FOOTER //
// ./search/static/search/js/utils/checkbox-dropdown.js